import {useMutation, useQueryClient} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {useModal} from "../../../../../hooks";
import {OrdersDetailType} from "../interface";
import {saveOrder} from "../../../../../api/order/OrdersApi";

export const useSaveOrder = ({closeCallback}: { closeCallback: () => any }) => {
    const {handleModal} = useModal();
    const qc = useQueryClient()

    const {mutate, mutateAsync} = useMutation({
        mutationFn: (data: OrdersDetailType) => saveOrder(data),
        onSuccess: (res) => {
            if (res.data.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: "수정되었습니다.",
                    type: "alert",
                    closeAction: () => {
                        qc.invalidateQueries({queryKey: ["readShipmentDetail"]})
                        qc.invalidateQueries({queryKey: ["readOrderSubjects"]})
                        closeCallback()
                    }
                });
            } else {
                const msgData: any = res.data

                handleModal({
                    isOpen: true,
                    contents: res.data.msg ?? msgData.message,
                    type: "alert",
                });
            }
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate, mutateAsync};
};
